/* ----------------- React Native Paper --------------- */
import { Card, Divider, Text } from "react-native-paper";
import { Button } from "../../Button";

/* ----------------- Components --------------- */
import CardContent from "./CardContent";

/* ----------------- Types --------------- */
import type { StatProps } from "../../StatItem";
import type { ScoreRange } from "./types";

/* ----------------- Components --------------- */
import Box from "../../Box";

/* ----------------- Index --------------- */
import { useDevice } from "../../../index";

type Props = {
	title: string;
	score: number;
	numPointsEarned: number;
	numTotalPoints: number;
	stats: StatProps[];
	numItems: number;
	handleContinue: () => void;
	scoreRanges: ScoreRange[];
	infoComp?: React.ReactNode;
	compositeColor: string;
	compositeScore: number;
};

const CardHeader = ({
	title,
	handleContinue,
}: Pick<Props, "title" | "handleContinue">) => {
	const { isMobile } = useDevice();

	return (
		<Box
			gap={16}
			flexDirection="column"
			alignItems="center"
			position="relative"
		>
			<Text style={{ textAlign: "center" }} variant="titleMedium">
				{title}
			</Text>
			{!isMobile && (
				<Button mode="contained" onPress={handleContinue}>
					Continue
				</Button>
			)}
		</Box>
	);
};

const StudySessionSummaryCard = ({
	infoComp,
	title,
	stats,
	handleContinue,
}: Props) => {
	const hasContent = stats.length > 0 || !!infoComp;
	return (
		<Card
			style={{
				width: "100%",
			}}
		>
			<Box gap={16} padding={16}>
				<CardHeader title={title} handleContinue={handleContinue} />
				{hasContent && <Divider />}
				{stats.length > 0 && <CardContent stats={stats} />}
				{infoComp}
			</Box>
		</Card>
	);
};

export default StudySessionSummaryCard;
